import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  & input {\n    padding: 0 16px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from '../../utils/styling/styled-components';
import { TEXT_INPUT } from '../../utils/testing/TestIDs';
import { BaseTextInputV3 } from './BaseTextInputV3';
import { HelperText } from './HelperText';

var NO_PASTE = function NO_PASTE(e) {
  e.preventDefault();
};

var StyledTextInput = styled(BaseTextInputV3)(_templateObject());

var TextInputV3 = function TextInputV3(_ref) {
  var error = _ref.error,
      errorText = _ref.errorText,
      helperText = _ref.helperText,
      inputProps = _ref.inputProps,
      label = _ref.label,
      className = _ref.className,
      _ref$testId = _ref.testId,
      testId = _ref$testId === void 0 ? TEXT_INPUT : _ref$testId;
  return /*#__PURE__*/React.createElement(StyledTextInput, {
    className: className,
    error: error,
    errorText: errorText,
    decorators: {
      bottom: helperText && /*#__PURE__*/React.createElement(HelperText, null, helperText)
    },
    inputProps: _objectSpread(_objectSpread({
      'data-testid': testId
    }, inputProps), {}, {
      type: 'text',
      onCopy: inputProps.noPaste && NO_PASTE,
      onPaste: inputProps.noPaste && NO_PASTE,
      onDrag: inputProps.noPaste && NO_PASTE,
      onDrop: inputProps.noPaste && NO_PASTE
    }),
    label: label
  });
};

export { TextInputV3 };